import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { tasksAndDecisionsMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import TaskIcon from '@atlaskit/icon/core/task';
export var TaskListBlockMenuItem = function TaskListBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isSelected = useMemo(function () {
    return selection && selection.$from.parent.type.name === 'taskItem';
  }, [selection]);
  var onClick = function onClick(event) {
    var _api$blockMenu;
    var inputMethod = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
    var triggeredFrom = INPUT_METHOD.BLOCK_MENU;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode('taskList', {
      inputMethod: inputMethod,
      triggeredFrom: triggeredFrom
    }));
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    isSelected: isSelected,
    onClick: onClick,
    elemBefore: /*#__PURE__*/React.createElement(TaskIcon, {
      label: ""
    })
  }, formatMessage(tasksAndDecisionsMessages.taskList));
};